<template>
  <div>
    <div v-if="showCardType" class="form-row">
      <div class="form-group col-md-12">
        <label for="Card Number">Card Type</label>
        <select v-model="cardType" class="form-control">
          <option value="master" selected>Master Card</option>
          <option value="visa">Visa Card</option>
        </select>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="Card Holder Name">Card Holder Name</label>
        <input
          v-validate="'required'"
          id="cardHolder"
          v-model="editModel.CardHolder"
          name="Card Holder Name"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Card Holder Name") }}</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-5">
        <label for="Card Number">Card Number</label>
        <input
          v-validate="'required|credit_card'"
          id="cardinput"
          v-model="editModel.CardNumber"
          name="Card Number"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Card Number") }}</div>
      </div>
      <div class="form-group col-md-5">
        <label for="Expiry Date">Expiry Date</label>
        <input
          v-validate="{ required: true, regex: /^((0[1-9])|([1-9])|(1[012]))\/((201[19])|(202[0-9]))$/ }"
          id="exInput"
          v-model.trim="editModel.ExpireDate"
          type="text"
          name="Expiry Date"
          class="form-control"
          placeholder="MM/YYYY"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Expiry Date") }}</div>
      </div>
      <div class="form-group col-md-2">
        <label for="CVV">CVV</label>
        <input
          v-validate="{ required: true, regex: /^[0-9]{3,4}$/ }"
          id="CVV"
          v-model="editModel.CVV"
          name="CVV"
          type="text"
          class="form-control"
          placeholder="111"
        />
        <div class="invalid-feedback">{{ OOErrors.first("CVV") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-component",
  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    Title: {
      type: String,
      default: () => ""
    },
    showCardType: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      cardType: "master"
    };
  },
  methods: {
    validate() {
      return this.$validator.validateAll();
    }
  }
};
</script>
